import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 1. COMPONENTS
import Footer from './components/Footer';
import SideNav from './components/SideNav';
import UserStatus from './components/UserStatus';

// 2. PAGES
import Landing from './pages/Landing';
import Signup from './pages/SignUp';
import Login from './pages/Login';
import Gatekeeper from './pages/Gatekeeper';
import MillionWall from './pages/MillionWall';
import Profile from './pages/Profile';
import ProfileView from './pages/ProfileView'; // <--- IMPORT ADDED
import Admin from './pages/Admin';
import Failed from './pages/Failed';
import Terms from './pages/Terms';
import Legal from './pages/Legal';
import About from './pages/About';
import SalesLab from './pages/SalesLab';
import StudioLab from './pages/StudioLab';
import ViabilityLab from './pages/ViabilityLab';
import ExitLab from './pages/ExitLab';

// 3. LAB PLACEHOLDERS
// LABS are imported above

function App() {
  return (
    <Router>
      <div style={styles.appWrapper}>
        <UserStatus />
        <div style={styles.contentWrapper}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/about" element={<About />} />

            {/* CORE APP ROUTES */}
            <Route path="/gatekeeper" element={<Gatekeeper />} />
            <Route path="/million-wall" element={<MillionWall />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />
            {/* Content route removed */}
            <Route path="/profile-view/:uid" element={<ProfileView />} /> {/* <--- ROUTE ADDED */}
            <Route path="/admin" element={<Admin />} />
            <Route path="/failed" element={<Failed />} />

            {/* LABS */}
            <Route path="/sales-lab" element={<SalesLab />} />
            <Route path="/studio-lab" element={<StudioLab />} />
            <Route path="/viability-lab" element={<ViabilityLab />} />
            <Route path="/exit-lab" element={<ExitLab />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

const styles = {
  appWrapper: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#000', position: 'relative' },
  contentWrapper: { flex: 1 }
};

export default App;
